import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';
import {
  Card as BaseCard,
  PostCard,
  CardFooter,
  InfoWrapper,
  MediumInfoWrapper,
  MediumStatsWrapper,
  SmallCard,
  GreyBar,
  AvatarWrapper,
} from 'legacyComponents/cards/styles';
import {
  AvatarIndicator,
  Indicator,
  Center,
} from 'legacyComponents/styled/lib';
import PropTypes from 'prop-types';

export const CardIndicator = observer(({ type, noMargin }) => {
  if (type === 'project' || type === 'collection') {
    return (
      <BaseCard noMargin={noMargin}>
        <ImgIndicator />
        <InfoWrapper>
          <PathIndicator />
          <DescriptionIndicator />
        </InfoWrapper>
        <CardFooter></CardFooter>
      </BaseCard>
    );
  }
  if (type === 'story') {
    return (
      <StoryCard noMargin={noMargin}>
        <StoryImgIndicator />
        <MediumInfoWrapper>
          <StoryTitleIndicator />
          <Indicator width='30%' margin='0 0 14px 0' />
        </MediumInfoWrapper>
        <MediumStatsWrapper />
      </StoryCard>
    );
  }
  if (type === 'post' || type === 'issue') {
    return (
      <PostCard>
        <UpvoteIndicator />
        <PostTitleIndicator />
        <PostDescriptionIndicator />
      </PostCard>
    );
  }
  if (type === 'activity') {
    return (
      <PostCard>
        <UpvoteIndicator />
      </PostCard>
    );
  }
  if (type === 'contributor') {
    return (
      <SmallCard noMargin={noMargin}>
        <UpvoteIndicator />
      </SmallCard>
    );
  }
  if (type === 'topic') {
    return (
      <SmallCard noMargin={noMargin}>
        <TagIndicator />
      </SmallCard>
    );
  }
  if (type === 'profile') {
    return (
      <ProfileCard noMargin={noMargin}>
        <GreyBar />
        <AvatarWrapper>
          <AvatarIndicator size='80px' />
        </AvatarWrapper>
        <Center>
          <Indicator height='20px' width='250px' margin='12px auto 0 auto' />
        </Center>
      </ProfileCard>
    );
  }
  if (type === 'sharedFile') {
    return (
      <SharedFileCard>
        <SharedFileImageIndicator />
        <ColumnBlockWrapper>
          <SharedFileTitleIndicator />
          <SharedFileDescriptionIndicator />
        </ColumnBlockWrapper>
      </SharedFileCard>
    );
  }
  return null;
});

const ProfileCard = styled(BaseCard)`
  height: 255px;
`;

const StoryCard = styled(BaseCard)`
  width: 100%;
  box-shadow: rgba(75, 75, 75, 0.2) 0 1px 1px;
  &:hover {
    > div:nth-child(1) {
      opacity: 0.9;
    }
  }
`;

const ImgIndicator = styled(Indicator)`
  height: 284px;
  margin-bottom: 4px;
  ${media.l`
    height: 230px;
  `};
  ${media.m`
    height: 250px;
  `};
  ${media.s`
    height: 200px;
  `};
  ${media.s`
    height: 240px;
  `};
`;

const StoryImgIndicator = styled(Indicator)`
  height: 265px;
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  ${media.l`
    height: 238px;
  `};
  ${media.m`
    height: 347px;
  `};
  ${media.s`
    height: 275px;
  `};
  ${media.xs`
    height: 200px;
  `};
`;

const StoryTitleIndicator = styled(Indicator)`
  width: 85%;
  height: 28px;
  margin: 0 0 8px 0;
`;

const PathIndicator = styled(Indicator)`
  margin: 0;
  height: ${props => props.theme.spacing.medium};
`;

const DescriptionIndicator = styled(Indicator)`
  margin: ${props => props.theme.spacing.default} 0 0;
  height: ${props => props.theme.spacing.default};
  width: 50%;
`;

const UpvoteIndicator = styled(Indicator)`
  width: 38px;
  height: 38px;
  border-radius: 100%;
  margin-right: 10px;
`;

const PostTitleIndicator = styled(Indicator)`
  width: 600px;
  height: 18px;
  position: absolute;
  top: 22px;
  left: 70px;
  ${media.l`
    width: 75%;
    height: 16px;
    left: 60px;
    top: 20px;
  `};
`;

const PostDescriptionIndicator = styled(Indicator)`
  height: 12px;
  width: 100px;
  position: absolute;
  bottom: 22px;
  left: 70px;
  ${media.l`
    width: 20%;
    height: 10px;
    left: 60px;
    bottom: 20px;
  `};
`;

const TagIndicator = styled(Indicator)`
  height: 22px;
  width: 95px;
`;

const SharedFileCard = styled.div`
  display: flex;
  width: 100%;
  height: 5.5rem;
  border: 1px solid ${props => props.theme.color.wfGrey300};
  margin: 0;
`;

const SharedFileImageIndicator = styled(Indicator)`
  width: 5.5rem;
  height: 100%;
`;

const SharedFileTitleIndicator = styled(Indicator)`
  width: 140px;
  height: 1rem;
  /* margin-top: 1.5rem; */
  margin-left: 1rem;
`;

const SharedFileDescriptionIndicator = styled(Indicator)`
  width: 70px;
  height: 0.55rem;
  margin-top: 0.5rem;
  margin-left: 1rem;
`;

export const ColumnBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 5.5rem;
  height: 100%;
  min-height: 5.5rem;
`;

CardIndicator.propTypes = {
  type: PropTypes.string,
  noMargin: PropTypes.bool,
};
